import React from 'react';
import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import usePermissions from '../auth/usePermissions';
import '../styles/Settings.css';

const SETTINGS_TABS = [
  { to: 'company', label: 'My Company', key: 'settingsMyCompany', end: true },
  { to: 'billing', label: 'Billing', key: 'settingsBilling' },
  { to: 'team', label: 'My Team', key: 'settingsMyTeam' },
  { to: 'tax', label: 'Tax Locations', key: 'settingsTaxLocations' },
  { to: 'time-billing', label: 'Time Billing', key: 'settingsTimeBilling' },
  { to: 'sales-account', label: 'Sales Account', key: 'settingsSalesTax' },
  { to: 'invoice-template', label: 'Invoice Template', key: 'settingsInvoiceTemplate' },
  { to: 'proposal-template', label: 'Proposal Template', key: 'settingsProposalTemplate' },
  { to: 'quickbooks', label: 'Quickbooks', key: 'settingsQuickBooks', premiumOnly: true },
  { to: 'payments', label: 'Payments', key: 'settingsPayments' },
  { to: 'tags', label: 'Tags', key: 'settingsTags' },
  { to: 'client-portal', label: 'Client Portal', key: 'settingsClientPortal' },
  { to: 'message-templates', label: 'Message Templates', key: 'settingsMessageTemplates' },
  { to: 'email-branding', label: 'Email Branding', key: 'settingsEmailBranding' },
  { to: 'notifications', label: 'Notifications', key: 'settingsNotifications' },
];

export default function Settings() {
  const { auth } = useAuth();
  const { permissions, permissionsLoaded } = usePermissions();
  const location = useLocation();
  const isPremium = auth?.plan === 'premium';

  const visibleTabs = SETTINGS_TABS.filter((t) => permissions[t.key] !== false);

  // Handle the /settings root — redirect to first accessible sub-page
  const isRoot = location.pathname === '/settings' || location.pathname === '/settings/';
  if (isRoot) {
    if (!permissionsLoaded) return null;
    const first = visibleTabs[0];
    return <Navigate to={first ? first.to : '/dashboard'} replace />;
  }

  return (
    <div className="settings-page">
      <h1 className="settings-title">Settings</h1>

      <div className="settings-tabs">
        {visibleTabs.map((tab) => {
          if (tab.premiumOnly && !isPremium) {
            return (
              <span
                key={tab.to}
                className="settings-tab-locked"
                title="Upgrade to Premium to access QuickBooks integration"
              >
                {tab.label} <span className="lock-badge">Premium</span>
              </span>
            );
          }
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) => (isActive ? 'active' : '')}
              end={tab.end}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>

      <hr className="divider" />

      <div className="settings-content">
        <Outlet />
      </div>
    </div>
  );
}
